<div class="main-container">
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Sampark EOL </span>
    </div>
    @if (samparkEolDeviceCreate) {
      <div class="button-group">
        <button class="primary-button" (click)="AddNew()">
          Manual Upload <mat-icon class="btn-icon">open_in_new</mat-icon>
        </button>
      </div>
    }
  </div>

  @if (samparkEolDeviceView) {
    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">Sampark EOL Device List</h6>
        <div class="component-actions">
          <app-common-search
            (searchSubmit)="onSearchInputChange($event)"
          ></app-common-search>
        </div>
      </div>

      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>IMEI</th>
              <th>ICCID</th>
              <th>VIN No.</th>
              <th>AEPL Device Type</th>
              <th>TML Device Type</th>
              <th>Data Upload Status</th>
              <th>Action</th>
            </tr>
          </thead>
          @if (samparkEolDeviceList.length > 0) {
            <tbody>
              @for (item of samparkEolDeviceList; track item) {
                <tr>
                  <td>
                    {{ item.imei }}
                  </td>
                  <td>
                    {{ item.iccid }}
                  </td>
                  <td>
                    {{ item.vinNo }}
                  </td>
                  <td>
                    {{ getAccountLabelById(item.accountId) }}
                  </td>
                  <td>
                    {{ item.deviceTypeName }}
                  </td>
                  <td>
                    <button
                      class="btn btn-sm"
                      [class.btn-success]="item.deviceUploadStatus"
                      [class.btn-warning]="!item.deviceUploadStatus"
                      [class.text-dark]="!item.deviceUploadStatus"
                      [disabled]="item.deviceUploadStatus"
                      (click)="uploadToTml(item.imei)"
                    >
                      {{ item.deviceUploadStatus ? 'Uploaded' : 'Pending' }}
                    </button>
                  </td>
                  <td>
                    <div class="action-buttons">
                      @if (samparkEolDeviceUpdate) {
                        <button
                          class="primary-button view-button"
                          (click)="prepopulation(item.imei)"
                        >
                          <mat-icon class="btn-icon">visibility</mat-icon>
                        </button>
                      }
                      @if (samparkEolDeviceDelete) {
                        <button
                          class="primary-button delete-button"
                          (click)="delete(item.imei)"
                        >
                          <mat-icon class="btn-icon">delete</mat-icon>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (samparkEolDeviceList.length === 0) {
            <tbody>
              <tr>
                <td colspan="7">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        @if (samparkEolDeviceList.length > 0) {
          <app-common-component-pagination
            [totalItems]="totalItems"
            [pageSize]="pageSize"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }
</div>
